import { render, staticRenderFns } from "./RawData.vue?vue&type=template&id=063e80a0&scoped=true"
import script from "./RawData.vue?vue&type=script&lang=ts"
export * from "./RawData.vue?vue&type=script&lang=ts"
import style0 from "./RawData.vue?vue&type=style&index=0&id=063e80a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063e80a0",
  null
  
)

export default component.exports